import shpjs from "shpjs";

const EFFIS_BASE =
  'https://maps.effis.emergency.copernicus.eu/effis?map=/mnt/nfs/mapfiles/wfra.map' +
  '&service=WMS&request=GetMap' +
  '&layers=danger-by-weather-fwi30-days' +
  '&styles=' +
  '&format=image/png' +
  '&transparent=true' +
  '&version=1.3.0' +
  '&crs=EPSG:3857';

export const addLandcoverLayer = (map) => {
  if (map.getLayer("landcover-2")) return;

  map.addLayer({
    id: "landcover-2",
    source: "composite",
    "source-layer": "landcover",
    type: "fill",
    paint: {
      "fill-color": [
        "match",
        ["get", "class"],
        "wood",
        "rgba(30, 109, 3, 0.8)",
        "scrub",
        "rgba(163, 212, 135, 0.6)",
        "crop",
        "rgba(198, 253, 18, 0.6)",
        "grass",
        "rgba(178, 227, 150, 0.6)",
        "rgba(0, 0, 0, 0)",
      ],
      "fill-opacity": 0.5,
      "fill-outline-color": "rgba(0,0,0,0)",
    },
  });
};

export const add3DBuildingsLayer = (map) => {
  map.addLayer({
    id: 'building-hit',
    type: 'fill',
    source: 'composite',
    'source-layer': 'building',
    filter: ['==', 'extrude', 'true'],
    paint: { 'fill-opacity': 0 },
    layout: {
      visibility: "none"
    }
  });

  map.addLayer({
    'id': '3d-buildings',
    'source': 'composite',
    'source-layer': 'building',
    'filter': ['==', 'extrude', 'true'],
    'type': 'fill-extrusion',
    'minzoom': 15,
    'paint': {
      'fill-extrusion-color': '#0011a8',
      'fill-extrusion-height': [
        'interpolate',
        ['linear'],
        ['zoom'],
        15,
        0,
        15.05,
        ['get', 'height'],
      ],
      'fill-extrusion-base': [
        'interpolate',
        ['linear'],
        ['zoom'],
        15,
        0,
        15.05,
        ['get', 'min_height'],
      ],
      'fill-extrusion-opacity': 0.6,
    },
    layout: {
      visibility: "none"
    }
  });
};

export const addSatelliteLayer = (map) => {
  if (map.getLayer("satellite-layer")) return;

  map.addSource("satellite-source", {
    type: "raster",
    url: "mapbox://mapbox.satellite",
    tileSize: 256,
  });

  map.addLayer({
    id: "satellite-layer",
    type: "raster",
    source: "satellite-source",
    paint: {
      "raster-opacity": 1,
    },
    layout: {
      visibility: "none"
    }
  });
}

export async function addFirePolygons(map) {
  const fillId = 'fire-polygons-fill';
  const lineId = 'fire-polygons-outline';
  if (map.getLayer(lineId) || map.getLayer(fillId)) return;

  const geojson = await shpjs('/data/scaled_poly');
  const sourceId = 'fire-polygons-src';
  const dn = ['coalesce', ['to-number', ['get', 'DN']], -1];
  const fillColor = [
    'case',
    ['<', dn, 0], '#BDBDBD',
    ['step', dn,
      '#66CDAA',
      20, '#F2C94C',
      60, '#e74331'
    ]
  ];

  const lineColor = [
    'case',
    ['<', dn, 0], '#8E8E8E',
    ['step', dn,
      '#3B9E7A',
      20, '#B08A1A',
      60, '#e74331'
    ]
  ];

  map.addSource(sourceId, { type: 'geojson', data: geojson });

  map.addLayer({
    id: fillId,
    type: 'fill',
    source: sourceId,
    paint: {
      'fill-color': fillColor,
      'fill-opacity': 0.35
    },
    layout: {
      visibility: "none"
    }
  });

  map.addLayer({
    id: lineId,
    type: 'line',
    source: sourceId,
    paint: {
      'line-color': lineColor,
      'line-width': 1.2,
      'line-opacity': 0.9
    },
    layout: {
      visibility: "none"
    }
  });
}

export function addEffisWms(map, tileSize = 256, opacity = 0.7) {
  const layerId = 'effis-wms-layer';
  if (map.getLayer(layerId)) return;

  const srcId = 'effis-wms-src';
  const tileUrl = `${EFFIS_BASE}&width=${tileSize}&height=${tileSize}&bbox={bbox-epsg-3857}`;

  map.addSource(srcId, {
    type: 'raster',
    tiles: [tileUrl],
    tileSize,
    attribution: '© EFFIS / Copernicus',
  });

  map.addLayer({
    id: layerId,
    type: 'raster',
    source: srcId,
    paint: { 'raster-opacity': opacity },
    layout: {
      visibility: "none"
    }
  });
}


export const ensureLotPerimeterLayersOnTop = (map) => {
  if (!map) return;
  ['line', 'line-outline'].forEach(id => {
    if (map.getLayer(id)) map.moveLayer(id);
  });
};